import React, { ReactNode } from 'react';

import { Callout, FlyThemeColor, getFlyToRadixColor } from '@fly/core';
import { Separator } from '@radix-ui/themes';
import classNames from 'classnames';

export interface FlyToastProps {
  size?: '1' | '2' | '3';
  variant?: 'soft' | 'surface' | 'outline';
  color?: FlyThemeColor;
  icon?: string | null;
  className?: string;
  onClose?: () => void;
  children: ReactNode;
}
export const FlyToast: React.FC<FlyToastProps> = ({
  size = '2',
  variant = 'soft',
  color = 'neutral',
  icon = 'info_circled',
  onClose,
  children,
  className = '',
}) => {
  return (
    <Callout
      variant={variant}
      size={size}
      onClose={onClose}
      className={classNames(
        'min-h-[40px] max-w-[411px] min-w-[200px] items-center !gap-fly-4 text-size-fly-2',
        className
      )}
      isToast
      icon={icon}
      color={getFlyToRadixColor(color)}
    >
      <div className='flex-1 text-(--text-color)'>{children}</div>
      <div className='flex items-stretch self-stretch'>
        <Separator
          size='4'
          orientation='vertical'
          className='w-px self-stretch'
        />
      </div>
    </Callout>
  );
};
